import { Button, Modal, Row, Col, Divider, Form, Table, Popconfirm, message, Select } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { SetStateAction, useContext, useEffect, useState } from 'react';
import { AddressDelivery } from '../../../Pages/Prescription/InterfaceType';
import DeliveryAddressForm from './DeliveryAddressForm';
import { createDeliveryAddress, getProfileAddress } from '../../../Services/Profile.service';
import { DataContext } from '../../../Pages/Prescription/PrescriptionForm';

export const DeliveryAddressModal = ({
  open,
  onCancel,
  addressList,
  addressType,
  profileId,
  setAddressList,
  setAddAddress,
}: {
  open: boolean;
  onCancel: () => void;
  addressList: AddressDelivery[];
  addressType: string;
  profileId: string;
  setAddressList: React.Dispatch<SetStateAction<AddressDelivery[]>>;
  setAddAddress: React.Dispatch<SetStateAction<AddressDelivery[]>>;
}) => {
  const { prescriptData, initialData, addressData, setIsRefetch } = useContext(DataContext);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<AddressDelivery | null>(null);
  const [addressDatas, setAddressDatas] = useState<AddressDelivery[]>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const columns: ColumnsType<AddressDelivery> = [
    {
      title: 'ชื่อ',
      dataIndex: 'name',
      align: 'center',
      width: '20%',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'phone_number',
      align: 'center',
      width: '10%',
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      align: 'center',
      width: '40%',
      render: (address) => <div>{address}</div>,
    },
    {
      title: 'การจัดส่ง',
      dataIndex: '',
      align: 'center',
      render: (record) => (
        <div>
          <p>
            {record.is_fast_delivery === 'Y' ? (
              <span style={{ color: 'green' }}>มีบริการจัดส่งด่วน</span>
            ) : record.is_fast_delivery === 'N' ? (
              <span style={{ color: 'red' }}>ไม่มีบริการจัดส่งด่วน</span>
            ) : (
              ''
            )}
          </p>
        </div>
      ),
    },
    {
      title: 'จัดการ',
      dataIndex: '',
      align: 'center',
      width: '15%',
      render: (item) => (
        <div>
          <Row>
            <Col span={24}>
              <Button
                type="primary"
                onClick={() => selectedAddressList(item)}
                disabled={addressType === '2' ? item.is_fast_delivery === 'N' : false}
              >
                เลือก
              </Button>
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  const handleAddAddress = () => {
    setSelectedAddress(null);
    setIsEdit(false);
    setIsOpenModal(true);
  };

  const handleCancel = () => {
    setIsOpenModal(false);
  };
  const submitAddress = async (value: any) => {
    const [latitude, longitude] = value.latitude_longitude
      ? value.latitude_longitude.split(',').map(parseFloat)
      : [0, 0];
    const data = {
      address_type: addressType,
      name: value.name,
      phone_number: value.phone_number,
      profile_id: profileId,
      zipcode: value.zipcode,
      sub_district_code: value.district_code,
      first_address: value.address,
      latitude: latitude,
      longitude: longitude,
    };

    const resDataCreateAddress = await createDeliveryAddress(data);

    if (resDataCreateAddress?.res_code === '000') {
      message.success('บันทึกข้อมูลเสร็จสิ้น');
      setIsRefetch(true);
      handleCancel();
    } else if (resDataCreateAddress?.res_code === 'E101') {
      message.error('ตรวจสอบข้อมูลไม่สำเร็จ ไม่พบสมาชิก');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (addressList && profileId) {
          const resAddress = await getProfileAddress(profileId);
          setAddressDatas(resAddress.datas.delivery_address);
        }
      } catch (error) {
        console.error('Error fetching profile address data:', error);
      }
    };
    fetchData();
  }, [addressList, profileId]);

  useEffect(() => {
    setAddressDatas(addressList);
  }, [addressList]);

  const selectedAddressList = (item: any) => {
    setSelectedRowId(item._id);
    setAddAddress(item);
    onCancel();
  };
  useEffect(() => {
    if (prescriptData) {
      if (prescriptData.delivery_info) {
        setSelectedRowId(prescriptData.delivery_info.profile_address_id);
      }
    }
  }, [prescriptData]);

  const rowClassName = (record: any) => {
    return record._id === selectedRowId ? 'selected-row' : '';
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="ที่อยู่จัดส่ง"
      centered
      width={1400}
      footer={[
        <Button key="back" type="default" onClick={onCancel}>
          ปิด
        </Button>,
      ]}
    >
      <Divider />
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item>
            <Button
              type="primary"
              style={{ color: '#fff', backgroundColor: '#50B0E9', width: '140px', justifyContent: 'flex-end' }}
              onClick={handleAddAddress}
            >
              เพิ่ม
            </Button>
            <DeliveryAddressForm
              form={form}
              open={isOpenModal}
              onCancel={handleCancel}
              addressType={addressType}
              onSubmit={submitAddress}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name={' '}
            style={{
              display: 'inline-block',
              width: 'calc(100% - 8px)',
            }}
          >
            <Table
              bordered
              rowKey={(record: AddressDelivery) => record._id}
              columns={columns}
              dataSource={addressDatas}
              rowClassName={rowClassName}
              pagination={false}
              scroll={{ y: 500 }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeliveryAddressModal;
